<template>
  <v-dialog
    scrollable
    @input="$emit('update:opened', $event)"
    :value="opened"
    max-width="1000px"
  >
    <v-card>
      <v-card-title>
        <v-container>
          <div class="display-1 font-weight-bold mb-4">
            Vybrat médium
          </div>
          <v-text-field
            v-model="search"
            :items="posts"
            outlined
            clearable
            prepend-inner-icon="mdi-magnify"
            placeholder="Zadejte klíčové slovo nebo ID"
            hide-details="auto"
          />
        </v-container>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-data-table
          :search="search"
          :headers="headers"
          :items="posts"
          single-select
          show-select
          @item-selected="$emit('update:selected', $event.item.id)"
        >
          <template v-slot:item.image="{ item }">
            <v-img
              :src="item.image"
              width="64"
              height="64"
              class="rounded my-1"
            />
          </template>
          <template v-slot:item.createdAt="{ item }">
            <ui-datetime date :value="item.createdAt" />
          </template>
        </v-data-table>
      </v-card-text>
      <v-divider />
      <v-card-actions class="c-dialog__footer">
        <v-container class="d-flex justify-space-between px-6">
          <v-btn text @click="$emit('update:opened', false)">
            Zavřít
          </v-btn>
          <v-btn
            color="primary"
            class="c-btn"
            @click="
              $emit('confirm')
              $emit('update:opened', false)
            "
          >
            Vybrat
          </v-btn>
        </v-container>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
const headers = [
  { text: "", value: "image", sortable: false, filterable: false },
  { text: "Příspěvek", value: "text" },
  { text: "ID příspěvku", value: "id", sortable: false },
  { text: "Vytvořeno", value: "createdAt" },
]

export default {
  props: {
    posts: { type: Array, required: true },
    opened: { type: Boolean, default: false },
    selected: { type: String, default: null },
  },
  emits: {
    "update:opened": e => typeof e === "boolean",
    "update:selected": null,
    "confirm": null,
  },
  data() {
    return {
      search: "",
      headers,
    }
  },
}
</script>
